//
// LayoutProxy.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import EventDispatcher from "../events/EventDispatcher";
import "../lib";
import "../models/BaseUIModel";
import "../util/Dimension";
import "./strategy/LayoutStrategy";
import "./constraints/LayoutConstraint";

var LayoutProxy = createModule("commons_LayoutProxy", [130,13,10004,10048], EventDispatcher, [
    ,
    {
        grow: 2,
        cumulativeExtraHeight: 5,
        cumulativeExtraWidth: 5,
        defaultConstraint: 1,
        children: [1],
        w: 1,
        childrenPerLine: [4],
        x: 1,
        h: 1,
        y: 1,
        isDisabled: 2,
        defaultStrategy: 1,
    },
    ,
    ,
    {
        getStrategy: [1],
        layout: [0,1],
        setNarrowScreenLayout: [0,2],
        getConstraint: [1],
        getBoundsInPixels: [12],
        setBoundsInPixels: [0,12],
        disable: [0],
        enable: [0],
        translate: [0,11],
    },
    {
        _create: [4],
    },
    ,
]);
export default LayoutProxy;
